// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.landlord.v1.CappsLandlordApplicationActionsWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  CappsLandlordApplicationActionsWebApiHandler_approveApplication,
  CappsLandlordApplicationActionsWebApiHandler_conditionallyApproveApplication,
  CappsLandlordApplicationActionsWebApiHandler_declineApplication,
} from '@zg-rentals/ts-capps-client';

import type {
  ApproveApplicationRequest,
  ConditionallyApproveApplicationRequest,
  DeclineApplicationRequest,
} from '@zg-rentals/ts-capps-client';

export interface CappsLandlordApplicationActionsWebApiHandler_approveApplication_Args {
  postData: ApproveApplicationRequest;
}

export type CappsLandlordApplicationActionsWebApiHandler_approveApplication_Options = UseMutationOptions<
  void,
  unknown,
  CappsLandlordApplicationActionsWebApiHandler_approveApplication_Args
>;

export const useCappsLandlordApplicationActionsWebApiHandler_approveApplication = ({
  httpClient,
  ...options
}: Omit<CappsLandlordApplicationActionsWebApiHandler_approveApplication_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: CappsLandlordApplicationActionsWebApiHandler_approveApplication_Args) =>
      CappsLandlordApplicationActionsWebApiHandler_approveApplication(args.postData, httpClient),
  });
};

export interface CappsLandlordApplicationActionsWebApiHandler_conditionallyApproveApplication_Args {
  postData: ConditionallyApproveApplicationRequest;
}

export type CappsLandlordApplicationActionsWebApiHandler_conditionallyApproveApplication_Options = UseMutationOptions<
  void,
  unknown,
  CappsLandlordApplicationActionsWebApiHandler_conditionallyApproveApplication_Args
>;

export const useCappsLandlordApplicationActionsWebApiHandler_conditionallyApproveApplication = ({
  httpClient,
  ...options
}: Omit<CappsLandlordApplicationActionsWebApiHandler_conditionallyApproveApplication_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: CappsLandlordApplicationActionsWebApiHandler_conditionallyApproveApplication_Args) =>
      CappsLandlordApplicationActionsWebApiHandler_conditionallyApproveApplication(args.postData, httpClient),
  });
};

export interface CappsLandlordApplicationActionsWebApiHandler_declineApplication_Args {
  postData: DeclineApplicationRequest;
}

export type CappsLandlordApplicationActionsWebApiHandler_declineApplication_Options = UseMutationOptions<
  void,
  unknown,
  CappsLandlordApplicationActionsWebApiHandler_declineApplication_Args
>;

export const useCappsLandlordApplicationActionsWebApiHandler_declineApplication = ({
  httpClient,
  ...options
}: Omit<CappsLandlordApplicationActionsWebApiHandler_declineApplication_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: CappsLandlordApplicationActionsWebApiHandler_declineApplication_Args) =>
      CappsLandlordApplicationActionsWebApiHandler_declineApplication(args.postData, httpClient),
  });
};
